const DOMESTIC_WEIGHTS = [7, 3, 1];

const mod97 = (digits: string): number => {
	let remainder = 0;
	for (const digit of digits) {
		remainder = (remainder * 10 + Number(digit)) % 97;
	}
	return remainder;
};

/** Finnish domestic reference: 3–19 base digits and a 7-3-1 check digit. */
const isValidDomesticReference = (reference: string): boolean => {
	if (!/^[1-9]\d{3,19}$/.test(reference)) return false;

	const sum = [...reference.slice(0, -1)]
		.reverse()
		.reduce(
			(total, digit, index) =>
				total +
				Number(digit) * DOMESTIC_WEIGHTS[index % DOMESTIC_WEIGHTS.length],
			0
		);

	return (10 - (sum % 10)) % 10 === Number(reference.slice(-1));
};

/** ISO 11649 RF reference wrapping a 4–20 digit Finnish reference. */
const isValidRfReference = (reference: string): boolean =>
	/^RF\d{2}[1-9]\d{3,19}$/.test(reference) &&
	mod97(`${reference.slice(4)}2715${reference.slice(2, 4)}`) === 1;

/**
 * A Finnish domestic or RF reference. Mirrors the component library's
 * validator, whose `"use client"` bundle throws when called on the server.
 */
export const isValidFinnishReference = (value: string): boolean => {
	const reference = value.replace(/\s/g, "").toUpperCase();
	return isValidDomesticReference(reference) || isValidRfReference(reference);
};
